module.exports = __webpack_public_path__ + "static/img/mood7.606da1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood7.png
// module id = niC7
// module chunks = 1